import { render } from "./MTableContents.vue?vue&type=template&id=c8f254c0&scoped=true&ts=true"
import script from "./MTableContents.vue?vue&type=script&lang=ts"
export * from "./MTableContents.vue?vue&type=script&lang=ts"

import "./MTableContents.vue?vue&type=style&index=0&id=c8f254c0&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8f254c0"]])

export default __exports__